module.exports = __webpack_public_path__ + "img/img_fqhd.87bb3611.png";